import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icon-warning.svg'


const _hoisted_1 = {
  key: 0,
  class: "jr-font-medium jr-text-primary jr-text-lg jr-mb-6.252"
}
const _hoisted_2 = { class: "jr-ml-35" }
const _hoisted_3 = {
  key: 1,
  class: "jr-flex jr-p-5 jr-items-center"
}
const _hoisted_4 = { class: "jr-flex jr-justify-center jr-relative" }
const _hoisted_5 = { class: "jr-absolute jr-flex jr-flex-col jr-justify-center jr-items-center jr-w-full jr-h-full" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "jr-text-lg jr-font-medium" }, "平均滞在", -1)
const _hoisted_7 = { class: "jr-text-lg jr-font-medium" }
const _hoisted_8 = { class: "jr-ml-5" }
const _hoisted_9 = { class: "jr-align-middle jr-ml-2 jr-text-base" }
const _hoisted_10 = { class: "jr-mt-25" }
const _hoisted_11 = { class: "jr-flex jr-items-center" }
const _hoisted_12 = { class: "jr-relative jr-bg-white jr-m-auto jr-text-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "jr-text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "jr-m-auto",
    src: _imports_0,
    alt: "icon-warning"
  })
], -1)
const _hoisted_14 = { class: "jr-text-xl jr-text-primary jr-mt-6.5 jr-font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DoughnutChart = _resolveComponent("DoughnutChart")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'jr-pt-12': _ctx.label })
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.average) + "時間", 1)
            ], 512), [
              [_vShow, _ctx.times.length > 0]
            ]),
            _createVNode(_component_DoughnutChart, _mergeProps({ style: _ctx.doughnutStyle }, _ctx.doughnutChartProps), null, 16, ["style"])
          ]),
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (d, i) => {
              return (_openBlock(), _createElementBlock("li", { key: i }, [
                _createElementVNode("div", {
                  class: "jr-w-4 jr-h-4 jr-inline-block jr-align-middle",
                  style: _normalizeStyle({ 'background-color': _ctx.chartData.datasets[0].backgroundColor[i] })
                }, null, 4),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.chartData.labels[i]) + " " + _toDisplayString(d) + "%", 1)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("figure", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", null, _toDisplayString(_ctx.title), 1)
          ])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.isError]
    ])
  ], 2))
}